import React, { useState } from "react";
import { ReactComponent as SearchIcon } from "../../../assets/images/Searchicon.svg";
import { ReactComponent as ImportIcon } from "../../../assets/images/Import.svg";

import { AppMaterialIcons } from "../../../AppComponents/AppMaterialIcons";
import { StyledAppInput } from "../../BotBuilder/BotKnowledge/BotKnowledgeStyles";
import AppButton from "../../../AppComponents/AppButton";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  IconButton,
  MenuItem,
} from "@mui/material";
import { StyledInput, StyledLabel, StyledSelect } from "../style";
import AppModel from "../../../Hooks/useModel/AppModel";
import { convertCurlToJson } from "./utils";

const TopMenuComponent = (props: any) => {
  const navigate = useNavigate();
  const [curlUrl, setCurlUrl] = useState<string>("");
  const [importModel, setImportModel] = useState<boolean>(false);

  const handleNavigations = () => {
    let curlObj;
    if (curlUrl) {
      curlObj = convertCurlToJson(curlUrl);
    }
    navigate("/api/library/create", { state: curlObj });
  };

  return (
    <div className="topmenu">
      <div
        className="menu-left"
        id="api-library-header"
        onClick={() => (props?.hideFilters ? navigate("/api/library") : null)}
      >
        {props?.hideFilters ? (
          <AppMaterialIcons
            iconName={"ArrowBackIosOutlined"}
            style={{ fontSize: "18px", marginRight: "-25px" }}
          />
        ) : null}
        API Library
      </div>
      {!props?.hideFilters ? (
        <div className="menu-right">
          <div className="faq-search" >
            <div className="faq-search" style={{ marginRight: "1rem" }}>
              <StyledAppInput>
                <input
                  type="text"
                  onChange={(e: any) => {
                    const trimmedValue = e.target.value.trim();
                    props?.handleSelectSearch( trimmedValue);
                  }}
                  name="query"
                  id="api-library_search_query"
                  placeholder="Search"
                />
                <SearchIcon />
              </StyledAppInput>
            </div>
          </div>
          <StyledSelect
            value={props?.method}
            onChange={props?.handleChangeMethod}
            id="api-library_filter_status"
            displayEmpty
            sx={{
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#FF5722", // Custom color for the border
              },
              ".Mui-selected": {
                color: "#FF5722",
                fontSize: "13px",  // Custom color for the selected text
              },
              ".MuiSelect-select": {
                fontSize: "13px", // Set font size for the selected value
              },

            }}
          >
            {/* Placeholder */}
            <MenuItem value="" disabled sx={{ fontSize: "13px" }}>
              Filter by method
            </MenuItem>

            {/* Options */}
            <MenuItem value="" sx={{ fontSize: "13px" }}>ALL</MenuItem>
            <MenuItem value="GET" sx={{ fontSize: "13px" }}>GET</MenuItem>
            <MenuItem value="POST" sx={{ fontSize: "13px" }}>POST</MenuItem>
            <MenuItem value="PUT" sx={{ fontSize: "13px" }}>PUT</MenuItem>
            <MenuItem value="DELETE" sx={{ fontSize: "13px" }}>DELETE</MenuItem>
            <MenuItem value="PATCH" sx={{ fontSize: "13px" }}>PATCH</MenuItem>
          </StyledSelect>


          <AppButton
            buttonStyle={{
              marginRight: "16px",
              marginLeft: "6px",
              padding: "14px 10px 14px 5px",
            }}
            onClick={() => setImportModel(true)}
            id="api-library_import_apis"
          >
            <ImportIcon id="api-library_import_api" />
            Import API's
          </AppButton>
          <AppButton
            buttonStyle={{
              padding: "14px 10px 14px 3px",
            }}
            onClick={handleNavigations}
            id="api-library_create"
          >
            <AppMaterialIcons iconName="add" />
            Create
          </AppButton>
        </div>
      ) : null}

      <AppModel
        style={{ width: "100%", padding: "0", borderRadius: "10px" }}
        onClose={() => setImportModel(false)}
        isShowing={importModel}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between", // for space between label and button
            alignItems: "center",
            padding: "10px 15px",
          }}
        >
          <StyledLabel>
            Insert CURL <sup style={{ color: "red" }}>*</sup>
          </StyledLabel>
          <IconButton
            aria-label="close"
            onClick={() => setImportModel(false)}
            size="small"
          >
            <AppMaterialIcons iconName="Close" />
          </IconButton>
        </Box>
        <Divider />
        <Box sx={{ padding: "25px 15px" }}>
          <StyledInput
            fullWidth
            multiline
            rows={6}
            placeholder="Paste your URL here..."
            value={curlUrl}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setCurlUrl(e.target.value)
            }
            sx={{
              width: "500px",
              border: "1px solid #F5F6F8",
              borderRadius: "15px",
              backgroundColor: "#fff",
            }}
            required
          />
        </Box>
        <Divider />
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "20px 15px",
            gap: "1rem"
          }}
        >
          <AppButton
            buttonStyle={{
              padding: "10px 30px",
            }}
            variant="grey"
            onClick={() => setImportModel(false)}
          >
            Cancel
          </AppButton>
          <AppButton
            buttonStyle={{
              padding: "10px 30px",
            }}
            variant="outline"
            onClick={() => handleNavigations()}
          >
            Insert
          </AppButton>
        </Box>
      </AppModel>
    </div>
  );
};

export default TopMenuComponent;
